import { render } from "./GoogleAuthButton.vue?vue&type=template&id=4a5fb36e&scoped=true"
import script from "./GoogleAuthButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleAuthButton.vue?vue&type=script&setup=true&lang=js"

import "./GoogleAuthButton.vue?vue&type=style&index=0&id=4a5fb36e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5fb36e"],['__file',"src/components/ui/GoogleAuthButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a5fb36e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a5fb36e', __exports__)) {
    api.reload('4a5fb36e', __exports__)
  }
  
  module.hot.accept("./GoogleAuthButton.vue?vue&type=template&id=4a5fb36e&scoped=true", () => {
    api.rerender('4a5fb36e', render)
  })

}


export default __exports__